module.exports = __webpack_public_path__ + "static/media/maheshbhusanoor@upi1593853002948.96ee131d.jpg";